// Header.js - Enhanced with modern interactions
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import HeaderSearchBar from './HeaderSearchBar';
import '../StylesComponents/header.css';

function Header({ menuOpen, setMenuOpen, currentUser, isVisible, searchQuery, setSearchQuery }) {
  const location = useLocation();
  
  const handleMenuClick = () => {
    setMenuOpen(!menuOpen);
  };
  
  const getLinkClass = (path) => {
    return location.pathname === path ? 'active' : '';
  };
  
  return (
    <header className={`header-container ${!isVisible ? 'hidden' : ''}`}>
      <div className="header-left">
        <div 
          className={`hamburger-menu ${menuOpen ? 'active' : ''}`} 
          onClick={handleMenuClick}
          aria-label="Toggle menu"
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleMenuClick();
            }
          }}
        >
          <div className="line"></div>
          <div className="line"></div>
        </div>
        <div className="logo-container">
          <Link to="/" className="logo-wrapper" aria-label="Stockroom home">
            <span className="brand-logo-text">
              <span className="brand-logo-stock">Stock</span><span className="brand-logo-room">room</span>
            </span>
          </Link>
        </div>
      </div>

      <div className="header-search-slot">
        <HeaderSearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
      </div>

      <nav className="user-icons" role="navigation" aria-label="Main navigation">
        <Link to="/about" className={getLinkClass('/about')} aria-label="About page">
          About
        </Link>
        <Link 
          to={currentUser ? "/profile" : "/signin"}
          className={`${getLinkClass(currentUser ? "/profile" : "/signin")} desktop-auth-link`}
        >
          {currentUser ? "Profile" : "Sign In"}
        </Link>
        <div className="pro-link-wrapper coming-soon-tooltip">
          <Link 
            to="#" 
            className={`${getLinkClass('/pro')} pro-link-star maintenance-mode`} 
            aria-label="Pro page"
            onClick={(e) => e.preventDefault()}
          >
            PRO
            <FontAwesomeIcon icon={faStar} className="star-icon" />
          </Link>
          <span className="tooltip-text header-tooltip">COMING SOON</span>
        </div>
      </nav>
    </header>
  );
}

export default Header;
